import { DateTime } from 'luxon';

export function toDueDateTime(date) {
  if (!date) return undefined;
  if (DateTime.isDateTime(date)) {
    return date.isValid ? date : undefined;
  }
  if (date instanceof Date && !Number.isNaN(date.getTime())) {
    const dt = DateTime.fromJSDate(date);
    return dt.isValid ? dt : undefined;
  }
  return undefined;
}

export function isFutureDueDate(date) {
  const dt = toDueDateTime(date);
  if (!dt) return true;
  return dt.startOf('day') > DateTime.now().startOf('day');
}

export function serializeDueDate(date) {
  const dt = toDueDateTime(date);
  if (!dt) return undefined;
  return DateTime.utc(dt.year, dt.month, dt.day, 12).toISO();
}

export function earliestSelectableDueDate() {
  return DateTime.now().plus({ days: 1 }).startOf('day').toJSDate();
}
